import { render, staticRenderFns } from "./ManageProcessingMethodTypesModal.vue?vue&type=template&id=568dfa57&scoped=true"
import script from "./ManageProcessingMethodTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageProcessingMethodTypesModal.vue?vue&type=script&lang=js"
import style0 from "./ManageProcessingMethodTypesModal.vue?vue&type=style&index=0&id=568dfa57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568dfa57",
  null
  
)

export default component.exports